import React from 'react';
import { STATUS_COLOR_PALETTE } from './statusColorPalette';

/**
 * Rótulos em pt-BR para cada status de Inscrição (PSP). Devem seguir o enum psp_subscription_status.
 */
export const subscriptionStatusLabels = {
    em_andamento: 'Em andamento',
    aprovada: 'Aprovada',
    reprovada: 'Reprovada',
    reserva: 'Cadastro de Reserva'
};

const statusColors = {
    em_andamento: STATUS_COLOR_PALETTE.blue,
    aprovada: STATUS_COLOR_PALETTE.green,
    reprovada: STATUS_COLOR_PALETTE.red,
    reserva: STATUS_COLOR_PALETTE.yellow
};

/**
 * Retorna a célula de status da Inscrição: bolinha colorida seguida do texto.
 */
export const subscriptionStatusCell = (row) => {
    const color = statusColors[row.status] || STATUS_COLOR_PALETTE.grey;
    const label = subscriptionStatusLabels[row.status] || row.status || '-';

    return (
        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span
                style={{
                    display: 'inline-block',
                    width: '10px',
                    height: '10px',
                    borderRadius: '50%',
                    backgroundColor: color,
                    flexShrink: 0
                }}
            />
            {label}
        </span>
    );
};
